module.exports = __webpack_public_path__ + "static/media/mobile-2.4d0458d5.png";